import { Link } from 'react-router-dom';
import { CONTACT, ENGAGEMENT } from '../../data/siteData';

export const ContactCTA = () => (
  <section className="cta" data-testid="contact-cta">
    <div className="wrap">
      <div>
        <div className="mono light">Start small, scale with confidence</div>
        <h2>Let&apos;s discuss your BIM requirements.</h2>
        <div className="steps-list">
          {ENGAGEMENT.map((e) => (
            <div key={e.title}><b>{e.title}</b> {e.text}</div>
          ))}
        </div>
      </div>
      <div className="box">
        <span className="lbl">Email</span>
        <a className="mail" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        <span className="lbl">Office</span>
        <span>{CONTACT.address}</span>
        <Link to="/contact" className="btn btn-w">Tell us about your project <span className="ar">→</span></Link>
      </div>
    </div>
  </section>
);

export default ContactCTA;
